import {DataTable} from "primereact/datatable";
import {useEffect, useState} from "react";
import {Column} from "primereact/column";
import {LicenseListService} from "./LicenseList.service";
import {Button} from "primereact/button";
import "./licenseList.css";

const LicenseList = () => {
    const [licenseFilesList, setLicenseFilesList] = useState([]);
    const [selectedLicenseFile, setSelectedLicenseFile] = useState(null);
    const [loading,setLoading] = useState(true);

    const licenseListService = LicenseListService();

    const getLicenseList = () => {
        setLicenseFilesList([]);
        setLoading(true);
        licenseListService.then(result => {
            setLicenseFilesList(licenseListHandler(result.data));
            setLoading(false);
        });
    }

    const licenseListHandler = (data) => {
        return [...(data || [])].map((d) => {
            d.date = new Date(d.date);
            return d;
        });
    };

    useEffect(() => {
        getLicenseList();
    }, []);

    const dateBodyTemplate = (rowData) => {
        return formatDate(rowData.date);
    }

    const formatDate = (value) => {
        return value.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    };

    const renderHeader = () => {
        return (
            <div className="table-header">
                <h3>License Files</h3>
                <Button icon="pi pi-refresh" onClick={getLicenseList}/>
            </div>
        )
    };

    const actionBodyTemplate = (rowData) => {
        let fileName = rowData.name,
            fileUrl = "./service/licenses/" + fileName;
        return (
            <div className='flex justify-content-between align-content-center'>
                <span>
                    <a href={fileUrl} download={fileName} target="_blank"><i className='pi pi-download'/></a>
                </span>
            </div>
        )
    };

    const header = renderHeader();

    return (
      <div className="license-file-table">
          <div className="card">
              <DataTable
                  value={licenseFilesList}
                  className="p-file-table"
                  header={header}
                  rows={10}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink
                         CurrentPageReport RowsPerPageDropdown"
                  rowsPerPageOptions={[10,25,50]}
                  dataKey="name"
                  selection={selectedLicenseFile}
                  onSelectionChange={e => setSelectedLicenseFile(e.value)}
                  loading={loading}
                  responsiveLayout="scroll"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  paginator
                  rowHover>
                  <Column
                      selectionMode="multiple"
                      headerStyle={{width:'3em'}}
                  />
                  <Column
                      field="name"
                      header="File Name"
                      sortable
                      style={{minWidth:'14rem'}}  />
                  <Column
                      field="date"
                      header="Date"
                      sortable
                      style={{ minWidth: '8rem' }}
                      body={dateBodyTemplate}
                  />
                  <Column
                      field="action"
                      header="Actions"
                      style={{minWidth:'8rem'}}
                      body={actionBodyTemplate}
                  />
              </DataTable>
          </div>
      </div>
    );
}

export default LicenseList;
